import { useState } from 'react';

export const useBookingSuccess = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values, on) => {
    setLoading(true);
    setError(null);
    try {
      await on(values);
    } catch (err) {
      setError('Invalid booking success. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSubmit,
  };
};
